import React from 'react';
import { FormattedMessage } from 'translations';
import classnames from 'classnames';
import { Layout } from 'app/components/base/Layout';
import _ from 'lodash';
import Button from 'mz-ui-kit/core/Button';

import config from 'config';
import style from './style.css';


const messages = {
  tryAgain: { id: 'SEARCH_RESULTS.TRY_AGAIN' }
};

export const ErrorLayout = ({
  className,
  mobile,
  ...props
}) => {
  const {
    titleMessage,
    message,
    image,
    onTryAgain
  } = props;
  const modifiers = {
    [style.mobile]: mobile
  };

  const align = {
    mobile: 'start center',
    desktop: 'start start'
  }[mobile ? 'mobile' : 'desktop'];

  return (
    <Layout
      direction="column"
      align={align}
      className={classnames(style.container, style.error, className, modifiers)}
      nowrap
      {...props}
    >
      <h2 className={style.title}>
        <FormattedMessage {...titleMessage} />
      </h2>
      {message && (
        <p className={style.subtitle}>
          {_.isString(message) ? message : <FormattedMessage {...message} />}
        </p>
      )}
      {onTryAgain && (
        <p className={style.tryAgain}>
          <Button
            appearance="link"
            onClick={onTryAgain}
            style={{ color: config[config.TRY_AGAIN_LINK_COLOR] }}
          >
            <FormattedMessage {...messages.tryAgain} />
          </Button>
        </p>
      )}
      {image && (
        <Layout
          className={style.container}
          direction="column"
          align="center center"
          size="noshrink"
        >
          {image}
        </Layout>
      )}
    </Layout>
  );
};

// TODO: move to Flow types
// ErrorLayout.propTypes = {
//   className: PropTypes.string,
//   mobile: PropTypes.bool,
//   titleMessage: PropTypes.object.isRequired,
//   message: PropTypes.oneOfType([
//     PropTypes.object,
//     PropTypes.string
//   ]),
//   image: PropTypes.object,
//   onTryAgain: PropTypes.func
// };

export default ErrorLayout;
